import React from 'react';

import { css, media, after } from 'glamor';

type Props = {
  children: React.Element,
  compact: ?Boolean,
};

export default function ListGrid({children, compact = false}: Props) {
  if (compact) {
    return (
      <ul
        {...css({ margin: '0 -0.5vw', padding: '0', listStyle: 'none', overflow: 'auto' })}
        {...after({ content: '\'\'', display: 'table', clear: 'both' })}>
        {children.map(child =>
          <li key={child.key}
            {...css({ display: 'block', padding: '0.5vw', float: 'left', width: 'calc(100% / 3)' })}>
            {child}
          </li>
        )}
      </ul>
    );
  }

  return (
    <ul
      {...css({ margin: '0 -0.5vw', padding: 0, listStyle: 'none', overflow: 'auto' })}
      {...media('(min-width: 700px)', { margin: '0 -1vw' })}
      {...media('(min-width: 1000px)', { margin: '0 -1.2vw' })}
      {...after({ content: '\'\'', display: 'table', clear: 'both' })}>
      {children.map(child =>
        <li key={child.key}
          {...css({ display: 'block', padding: '0.5vw', float: 'left', width: 'calc(100% / 3)' })}
          {...media('(min-width: 700px)', { padding: '0.5vw 1vw', width: 'calc(100% / 4)' })}
          {...media('(min-width: 1000px)', { padding: '0.5vw 1.2vw', width: 'calc(100% / 6)' })}
          {...media('(min-width: 1701px)', { padding: '0.5vw 1.2vw', width: 'calc(100% / 8)' })}>
          {child}
        </li>
      )}
    </ul>
  );
}



// WEBPACK FOOTER //
// ../src/client/components/list/ListGrid.js